import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';

const Popup = ({ message, onClose }) => {
  return (
    <div style={styles.popupContainer}>
      <div style={styles.popup}>
        <p>{message}</p>
        <button onClick={onClose} style={styles.closeButton}>
          Close
        </button>
      </div>
    </div>
  );
};

export const EnquireForm = () => {
  const [status, setStatus] = useState(null); // Track form status
  const [showPopup, setShowPopup] = useState(false); // Control popup visibility
  const [popupMessage, setPopupMessage] = useState('');
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    setStatus('sending'); // Set status to "sending"

    // Log form data to check if it's being collected correctly
    const formData = new FormData(form.current);
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }

    emailjs
      .sendForm('service_g4sg6yv', 'template_vlv0ee4', form.current, 'NjnJnEbcO3czpk5uy')  // User key directly in the sendForm call
      .then(
        () => {
          setStatus('success'); // Set status to "success" on success
          setPopupMessage('Your message was sent successfully!');
          setShowPopup(true);

          // Clear form fields after successful submission
          form.current.reset();  // Reset the form using the ref
        },
        (error) => {
          setStatus('error'); // Set status to "error" on failure
          setPopupMessage('There was an error sending your message. Please try again.');
          setShowPopup(true);
          console.error("Error sending email: ", error);
        },
      );
  };

  const closePopup = () => {
    setShowPopup(false); // Close popup when the button is clicked
  };

  return (
    <div className='contactFrom'>
      <h1>Enquire Now</h1>
      <form className='heroEnquireForm' ref={form} onSubmit={sendEmail}>
        <input type="text" name="from_parentName" placeholder="Parents Name*" required />
        <input type="text" name="from_studentName" placeholder="Student Name*" required />
        <input type="email" name="from_parentemail" placeholder="Parent Email*" required />
        <input type="number" name="from_parentNumber" placeholder="Mobile Number*" required />
        <input type="text" name="from_parentState" placeholder="State*" required />
        <input type="text" name="from_parentCity" placeholder="City*" required />

        <select name="class" required>
  <option value="">Select Class *</option>
  <option value="Nur">Nur</option>
  <option value="K.G">K.G</option>
  <option value="I">I</option>
  <option value="II">II</option>
  <option value="III">III</option>
  <option value="IV">IV</option>
  <option value="V">V</option>
  <option value="VI">VI</option>
  <option value="VII">VII</option>
  <option value="VIII">VIII</option>
  <option value="IX">IX</option>
  <option value="X">X</option>
  <option value="XI">XI</option>
  <option value="XII">XII</option>
</select>
<textarea name="from_parentMessage" placeholder="Message" required></textarea>

        <input className='contactbtn' type="submit" value="Submit" />
      </form>

      {showPopup && <Popup message={popupMessage} onClose={closePopup} />}
    </div>
  );
};

const styles = {
  popupContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1000,
  },
  popup: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    textAlign: 'center',
    maxWidth: '400px',
    width: '100%',
  },
  closeButton: {
    marginTop: '10px',
    padding: '10px 20px',
    backgroundColor: '#007BFF',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
};
